export const metaReducerPath = 'meta';
